module.exports = "/_next/static/images/aa73ec1eb59a11b1c73d44b98bd1d121-floatingCard.svg.webp";